<template>
  <v-dialog v-model="dialog" lazy width="854">
    <v-card>
      <v-toolbar dense color="primary" dark>
        <v-toolbar-title>
          {{
            province._id
              ? $t('titles.global.updateModel', {
                  field: $tc('models.province'),
                })
              : $t('titles.global.newModel', { field: $tc('models.province') })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn dark icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap>
          <v-flex d-flex xs12 px-2>
            <translation-field
              ref="name"
              v-model="province.name"
              :label="$t('fields.global.name')"
            />
          </v-flex>

          <v-flex md6 xs12 px-2>
            <RegionField
              v-model="province.regionId"
              v-validate="'required'"
              clearable
              :label="
                $t('action.actions.select', { field: $tc('models.region') })
              "
              autocomplete="new-text"
              browser-autocomplete
              :data-vv-name="$tc('models.region')"
              :error-messages="errors.collect($tc('models.region'))"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-switch
              v-model="province.active"
              :label="$t('fields.global.active')"
              color="primary"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <span style="color: red">(*) &nbsp;</span>
        <span>{{ $t('action.messages.fieldRequired') }}</span>
        <v-spacer />
        <meta-button type="reset" :disabled="loading" @click="clear" />
        <meta-button
          v-if="!province._id"
          type="create"
          :loading="loading"
          @click="submit()"
        />
        <meta-button
          v-else
          type="update"
          :loading="loading"
          @click="submit()"
        />
        <meta-button type="cancel" @click="cancel" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import RegionField from '@/components/widgets/Input/RegionField'
import TranslationField from '@/components/widgets/Input/TranslationField'
import { parseObject } from '@/helpers/utils'

export default {
  name: 'ProvinceForm',
  components: {
    TranslationField,
    RegionField,
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      province: {},
    }
  },
  watch: {
    dialog(val) {
      if (!val) this.cancel()
    },
    selected: {
      handler: function (val) {
        if (val) this.province = Object.assign({}, parseObject(val))
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.province = parseObject(this.selected)
  },
  computed: {
    ...mapState({
      selected: (state) => state.provinces.selected,
      loading: (state) => state.provinces.loading,
    }),
  },
  methods: {
    ...mapActions({
      setCreate: 'provinces/create',
      setUpdate: 'provinces/update',
      reset: 'provinces/reset',
    }),
    submit() {
      Promise.all([this.validate(), this.$refs.name.validate()]).then(
        (valid) => {
          if (valid.some((valid) => !valid)) return

          let payload = Object.assign({}, this.province)
          if (!payload._id) {
            this.setCreate(payload).then((_) => {
              this.cancel()
            })
          } else {
            this.setUpdate(payload).then((_) => {
              this.cancel()
            })
          }
        }
      )
    },
    cancel() {
      this.clear()
      this.$emit('close')
    },
    clear() {
      this.reset()
      this.$validator.reset()
    },
  },
}
</script>
